<template>
  <div @click="click">
    <span class="hora">{{parseDate(row[column.field])}}</span>
    <span class="periodo-name">{{periodoNome(row[column.field])}}</span>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'DataItem',
  props: ['column', 'row'],
  methods: {
    parseDate (value) {
      if ((/\d{4}-\d{2}-\d{2}/).test(value)) {
        return moment(value).format('HH:mm')
      }
      return moment.unix(parseInt(value)).format('HH:mm')
    },
    periodoNome (value) {
      const hora = moment(value).format('HH:mm')
      if (hora < '12') {
        return 'Manhã'
      } else if ((hora > '12') && (hora < '18')) {
        return 'Tarde'
      } else {
        return 'Noite'
      }
    },
    click () {
      if (this.column && this.column.click) {
        this.column.click(this.row)
      }
      this.$emit('click', this.row)
    }
  }
}
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@200&family=Open+Sans:wght@300&display=swap');
.hora {
  display: block;
  font-size: 18px;
  font-family: 'Open Sans', sans-serif;;
  color: #333333;
  line-height: 24px;
  font-weight: 400;
}
.periodo-name {
  font-family: 'Open Sans', sans-serif;;
  font-size: 11px;
  text-align: left;
  line-height: 15px;
  color: #333333;
  font-weight: 400;
}
</style>
